<template>
    <div class="poster-container" :style="{width:layoutParameters.width + 'px',height:layoutParameters.height}">

        <div class="poster-wrap"
             :style="{backgroundImage: 'url(' + layoutParameters.backgroundImage + ')',backgroundColor:layoutParameters.backgroundColor,width:layoutParameters.width + 'px',height:layoutParameters.height  + 'px'}">
            <div class="poster-element" :style="{left: `${ele.position.x}px`, top: `${ele.position.y}px`}" v-for="(ele,index) in layoutParameters.elements" :key="index">
                <div class="poster-text" v-if="ele.type == 'TextElement'" v-html="ele.content" :style="getTextStyle(ele)"></div>
                <div class="poster-img" v-if="ele.type == 'ImageElement'" :style="{width:ele.width + 'px',height:ele.height+ 'px'}">
                    <img :src="ele.src" alt="">
                </div>

                <div class="poster-img" v-if="ele.type == 'CodeElement'" :style="{left: `${ele.position.x}px`, top: `${ele.position.y}px`,width:ele.size,height:ele.size}">
                    <vue-qr :margin="6" :text="codeUrl" :size="parseInt(ele.size)"></vue-qr>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import vueQr from 'vue-qr';
import { mapGetters } from 'vuex';
import httpRequest from '@/module_visitor/api/http.js';
import { CellGroup } from 'vant';

export default {
    props: {
        codeUrl: {
            type: String,
            default: '',
        },
        user: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            showShare: false,

            layoutParameters: {},
        };
    },
    components: {
        vueQr,
    },
    computed: {
        ...mapGetters(['defaultInfo']),
    },

    methods: {
        open() {
            this.showShare = true;
        },

        getTextStyle(element) {
            return {
                fontWeight: element ? element.fontWeight : 'normal',
                color: element ? element.color : '#000000',
                fontSize: element ? element.fontSize : '24px',
            };
        },

        getTPoster() {
            httpRequest.get(`/api/TPoster/getPoster`).then(res => {
                const { data, code, msg } = res.data;
                if (code == 200) {
                    const layoutStr = data.layoutParameters.replace('{userName}', this.user.name);
                    this.layoutParameters = JSON.parse(layoutStr);
                }
            });
        },

        getUrlCode() {
            // 截取url中的code方法
            var url = location.search;
            var theRequest = new Object();
            if (url.indexOf('?') != -1) {
                var str = url.substr(1);
                var strs = str.split('&');
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
                }
            }
            return theRequest;
        },
    },
    created() {
        this.getTPoster();
    },
};
</script>

<style lang="scss" scoped>
.poster-container {
    display: inline-block;
    .poster-wrap {
        background-size: cover;
        position: relative;
        .poster-element {
            position: absolute;
            .poster-text {
            }
            .poster-img {
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
}
</style>